import(/* webpackMode: "eager" */ "/var/www/Name-Arcane/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www/Name-Arcane/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/Name-Arcane/src/components/home/CategoryCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/Name-Arcane/src/components/home/FeatureSections.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/Name-Arcane/src/components/home/Hero.tsx");
